import ExpertProfileEditReviewItemComponent from './expert-profile-edit-review-item.component'

const ExpertProfileEditReviewItemModule = angular.module('cdbl.expert-profile-edit-review-item', [

])
  .component('cdblExpertProfileEditReviewItem', ExpertProfileEditReviewItemComponent)
  .name

export default ExpertProfileEditReviewItemModule
